import React from 'react'

type SummaryTitleProps = {}

const SummaryTitle: React.FC<SummaryTitleProps> = (props) => {
  return (
    <h5 key="title" className="mb-0">
      Benefit details
    </h5>
  )
}

export default SummaryTitle
